export default __webpack_public_path__ + "static/media/timeline_2.4adee107.svg";